import { ProcessFlowState } from './types';

export const getProcessFlow = (state: any): ProcessFlowState => {
	return state.processFlowState;
};
